<template>
  <div class="Download">
    <img src="../assets/logo_agent.png" class="logo">

    <div class="btns pof">
      <div class="and tac f36" @click="download(3)">
        <img src="../assets/Android.png">
        Android版下载
      </div>
    </div>
    
    <div class="pop pop--top" :class="{ 'pop--show': showOverlay }">
      <div class="pop__mask"></div>
      <div class="pop__container">
        <div class="img"><img src="../assets/live_weixin.5b15117f.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "../api/axios";

export default {
  name: "Download",
  data () {
    return {
      showOverlay: false
    }
  },
  methods: {
    download (appSystem) {
      let params = {
        appSystem
      };
      post("boot-app/api/v2/app/fzdAppVersion/findNewVersion", params)
        .then(res => {
          if (res.code == 200) {
            let a = document.createElement("a");
            a.href = res.data;
            a.click();
          } else {
            this.$message(res.message);
          }
        })
        .catch(err => {
          this.$message(err);
        });
    },
    isWeChat () {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.showOverlay = true
      }
    }
  }, mounted () {
    document.title = '分之道合伙人APP下载'
    this.isWeChat()
  }
};
</script>

<style scoped lang="scss">
.Download {
  background-image: url("../assets/down_bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 bottom;

  .logo {
    padding-top: 284px;
    width: 34%;
    height: auto;
  }

  .btns {
    bottom: 180px;
    width: 100%;

    div {
      width: 480px;
      height: 100px;
      line-height: 100px;
      border: 2px solid #fff;
      border-radius: 50px;
      color: #fff;
      margin: 60px auto 0;

      img {
        width: 38px;
        height: 46px;
        margin-right: 22px;
        vertical-align: text-bottom;
      }
    }
  }
}

.pop {
  visibility: hidden;
}
.pop--show {
  visibility: visible;
}
.pop__mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 14;
  background: rgba(0, 0, 0, 0.5);
  display: none;
}
.pop__mask--hide {
  background: 0 0;
}
.pop__container {
  position: fixed;
//   left: 50%;
//   top: 50%;
//   -webkit-transform: translate3d(-50%, -50%, 0);
//   transform: translate3d(-50%, -50%, 0);
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  z-index: 15;
  opacity: 0;
}
.pop--show .pop__container {
  opacity: 1;
}
.pop--show .pop__mask {
  display: block;
}
.pop--left .pop__container {
  left: 0;
  top: 50%;
  -webkit-transform: translate3d(-100%, -50%, 0);
  transform: translate3d(-100%, -50%, 0);
}
.pop--show.pop--left .pop__container {
  -webkit-transform: translate3d(0, -50%, 0);
  transform: translate3d(0, -50%, 0);
}
.pop--right .pop__container {
  right: 0;
  top: 50%;
  left: auto;
  -webkit-transform: translate3d(100%, -50%, 0);
  transform: translate3d(100%, -50%, 0);
}
.pop--show.pop--right .pop__container {
  -webkit-transform: translate3d(0, -50%, 0);
  transform: translate3d(0, -50%, 0);
}
.pop--bottom .pop__container {
  top: auto;
  left: 50%;
  bottom: 0;
  -webkit-transform: translate3d(-50%, 100%, 0);
  transform: translate3d(-50%, 100%, 0);
}
.pop--show.pop--bottom .pop__container {
  -webkit-transform: translate3d(-50%, 0, 0);
  transform: translate3d(-50%, 0, 0);
}
.pop--top .pop__container {
  //   left: 50%;
  //   -webkit-transform: translate3d(-50%, -100%, 0);
  //   transform: translate3d(-50%, -100%, 0);
}
.pop--show.pop--top .pop__container {
  //   -webkit-transform: translate3d(-50%, 0, 0);
  //   transform: translate3d(-50%, 0, 0);
  top: 0;
  left: 0;
  right: 0;
  padding-left: 60px;
  .img {
    width: 100%;
    height: 100%;
    img {
      width: 95%;
      height: 100%;
    }
  }
}
</style>
